import { getUser } from "./authService";
import http, { host } from "./httpService";
import { standerdDate, standerdDateForDataCreation } from "../utils/dataFilter";

export const getInvoiceDocumentDetails = async (invoiceId) => {
    return await http.get(host + "GetInvoiceDocumentDetails", {
      params: {invoiceId: invoiceId },
    });
  };


  export const InsertInvoiceDocDetailsForOCR = async (data) => {

    return await http.post(host + "InsertInvoiceDocDetailsForOCR", data);
  };
  

  export const updateinvoicedetails = async (data) => {
    try {
    
  
      const response = await http.post(host + "update-invoice-details", data);
  
     
      return response.data;
    } catch (error) {
      
      throw error;
    }
  };
 
  export const uploadInvoiceDocOCR = async(formData, invoiceNumber) => {
    return await http.post(host + `InsertInvPackDocKlearstack?invoiceNumber=${invoiceNumber}`, formData);
  };
  
  export const uploadInvoiceDocOCRVizio = async(formData, invoiceNumber) => {
    return await http.post(host + `InsertInvPackDocKlearstackVizio?invoiceNumber=${invoiceNumber}`, formData);
  };


  export const viewDoc = async (data) => {
    return await http.get(host + `ViewAbFile?FileName=${data}`)
  }
  
  export const getInvoiceCargoDocumentsStatus = async (startDate, endDate) => {
    return await http.get(host + "getInvoiceCargoDocumentsStatus", {
      params: { startDate: startDate, endDate: endDate },
    });
  };

  export const InsertOCRApiResponseLog = async (data) => {
    try {
      const response = await http.post(host + "InsertOCRApiResponseLog", data)
      return response.data;
    } catch (error) {
      
      throw error; // Rethrow the error for handling in the calling function
    }
  };
 export const getCompanyMasterDropDown = async () => {
  return await http.get(host + "GetCompanyMasterDropDown");
};
